export const baseURL = 'https://api.bettrtrade.com';
export const basePromoURL = 'https://bettrtrade.com';
export const dashboardName = 'BETTR Trade';
export const supportEmail = 'info@bettrtrade.com';
export const stripePubKey = 'pk_test_51OcuHXL3DGfoh8TSXeDwbg9gh6V1it38dO6noCecIYg2UXBnyLEBjb3lhfSGs6rnBIhVR0IHJ1CPc5HnuU53S18j00CewAJWWJ';